import { trapFocus } from '@shopify/theme-a11y'

const handleFirstTab = (e) => {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing')
    const menuSlideout = document.querySelector('menu-slideout')
    if (!menuSlideout.classList.contains('invisible')) {
      menuSlideout.classList.add('invisible')
    }

    if (!window.location.pathname.includes('/cart')) {
      const shopifyCart = document.querySelector('shopify-cart')
      if (!shopifyCart.classList.contains('invisible')) {
        shopifyCart.classList.add('invisible')
      }
    }

    window.removeEventListener('keydown', handleFirstTab)
    window.addEventListener('mousedown', handleMouseDownOnce)
  }
}

const handleMouseDownOnce = () => {
  document.body.classList.remove('user-is-tabbing')
  const menuSlideout = document.querySelector('menu-slideout')
  if (menuSlideout.classList.contains('invisible')) {
    menuSlideout.classList.remove('invisible')
  }

  if (!window.location.pathname.includes('/cart')) {
    const shopifyCart = document.querySelector('shopify-cart')
    if (shopifyCart.classList.contains('invisible')) {
      shopifyCart.classList.remove('invisible')
    }
  }

  window.removeEventListener('mousedown', handleMouseDownOnce)
  window.addEventListener('keydown', handleFirstTab)
}

window.addEventListener('keydown', (e) => {
  if(e.keyCode === 32 && document.body.classList.contains('user-is-tabbing') && !e.target.classList.contains('js-skip-link')) {
    e.preventDefault()
  }

  handleFirstTab(e)
})

export const handleArrowDown = (el, container) => {
  const parent = el.closest('li')
  const nextSiblingEl = parent.nextElementSibling
  if (nextSiblingEl) {
    trapFocus(container, {
      elementToFocus: nextSiblingEl.querySelector('a')
    })
  }
}

export const handleArrowUp = (el, container) => {
  const parent = el.closest('li')
  const prevSiblingEl = parent.previousElementSibling
  if (prevSiblingEl) {
    trapFocus(container, {
      elementToFocus: prevSiblingEl.querySelector('a')
    })
  }
}

const updateTitleIframes = () => {
  const handleMutation = (mutationList, observer) => {
    const iframeWebMessenger = Array.prototype.slice.call(document.querySelectorAll('iframe#web-messenger-container'))

    if (iframeWebMessenger.length) {
      iframeWebMessenger?.forEach(item => {
        item?.setAttribute('title', 'Web Messenger')
      })

      observer.disconnect();
    }
  };

  const observer = new MutationObserver(handleMutation);

  const targetNode = document.getElementsByTagName("BODY")[0];

  const config = { attributes: true, childList: true, subtree: true };

  observer.observe(targetNode, config);

  setTimeout(() => {
    const iframePixels = document.querySelector('#WebPixelsManagerSandboxContainer iframe')
    const joinAdInterestGroup = document.querySelectorAll('iframe[allow="join-ad-interest-group"]')
    const iframeBlank = document.querySelector('iframe[src="about:blank"]')

    iframeBlank?.setAttribute('role', 'none')
    iframeBlank?.setAttribute('aria-hidden', 'true')

    iframePixels?.setAttribute('title', 'WebPixels Manager Sandbox')

    joinAdInterestGroup?.forEach(item => {
      item?.setAttribute('title', 'Join ad Interest Group')

    })

    const widthIframeWebMessenger = (78 / window.innerWidth) * 100
    const heightIframeWebMessenger = (96 / window.innerHeight) * 100
    const iframeWebMessenger = document.querySelectorAll('iframe#web-messenger-container')
    iframeWebMessenger?.forEach(item => {
        item.width = widthIframeWebMessenger + '%'
        item.height = heightIframeWebMessenger + '%'
    })

  }, 5000)
}

updateTitleIframes()

//For eA- non-unique accessible name.
document.addEventListener("DOMContentLoaded", function () {
  const updateAriaLabels = () => {
    document.querySelectorAll('.bv_main_container.bv_inline_rating_container_left').forEach(el => {
      const href = el.getAttribute('href');
      const productId = href ? href.split('/').pop()?.split('?')[0] : '';

      const ratingText = el.querySelector('.bv_averageRating_component_container .bv_text')?.textContent?.trim() || '0.0';
      const reviewsTextRaw = el.querySelector('.bv_numReviews_component_container .bv_text')?.textContent?.trim() || '(0)';
      const reviewsCount = reviewsTextRaw.replace(/[()]/g, '');
      el.setAttribute('aria-label', `${ratingText} out of 5 stars. ${reviewsCount} reviews for product ${productId}`);
    });
  };

  // Run initially and when Bazaarvoice updates dynamically
  updateAriaLabels();

  // Observe for dynamically added nodes
  const observer = new MutationObserver(updateAriaLabels);
  observer.observe(document.body, { childList: true, subtree: true });
});
